import type { FC, ReactNode } from "react";

import { cn } from "../utils";

type AppTopBarListProps = {
	grow?: boolean;
	children?: ReactNode;
};

export const AppTopBarList: FC<AppTopBarListProps> = ({ children, grow }) => (
	<ul data-tauri-drag-region className={cn("flex items-center min-w-0 gap-2", grow && "flex-1")}>
		{children}
	</ul>
);

export type { AppTopBarListProps };
